import { ENV_RENDER_DESIGNER } from '@utils/constants'

export const isDesign = (renderEnv) => {
  return renderEnv === ENV_RENDER_DESIGNER;
}

export const getDesignStyle = (renderEnv) => {
  return isDesign(renderEnv) ? 'designer-style' : '';
}

export const getFieldId = (props) => {
  const { fieldid, fieldidPrefix } = props || {};
  return fieldid || fieldidPrefix;
};


export const handleCStyle = (cStyle) => {
  let style = {}
  try {
    style = JSON.parse(cStyle);
  } catch (err) {
  }
  return style
}
